module.exports = __webpack_public_path__ + "assets/w3w_logo-278b1f62073a75aee7dd265831efa701.webp";